<template>
  <div v-if="currentProduct">
    <div class="d-inline-block ml-3">Products:
      <filter-products :fieldData="carrierProductFilters" :widgetType="'radio'" :widgetStyle="'colorful'" class="d-inline-block mb-1"></filter-products>
    </div>

    <div class="row mx-3 py-4 border-bottom">
      <div class="col-12 col-xl-4 mb-3 mb-xl-0 pl-0 pr-0 pr-xl-3">
        <fieldset class="border border-primary p-2 rounded">
          <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">Select Agency</legend>
            <div class="row no-gutters">
              <platform-state :key="vendorMeta.name" :selectMeta="vendorMeta" :selectOptions="vendors" :agencyIntegrations="agencyIntegrations"></platform-state>
              <!-- <platform-state :key="agencyMeta.name" :selectMeta="agencyMeta" :selectOptions="agencies" :agencyIntegrations="agencyIntegrations"></platform-state> -->
              <input-select :fieldData="agencytype" />
            </div>
        </fieldset>
      </div>
      <div class="col-12 col-xl-8 pl-0 pl-xl-3 pr-0">
        <fieldset class="border border-primary p-2 rounded">
          <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">Appointed States</legend>

          <div class="row mx-1">
            <template v-for="(agencyState, key) in agencyStates">
              <agency-state
                :key="agencyStateKey(key)"
                :agencyState="agencyState"
                :selectOptions="agencyStateSelectOptions(agencyState)"
                :agencyIntegrations="agencyIntegrations" class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
              </agency-state>
            </template>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import FilterProducts from '../../../interactive/widgets/FilterProducts';
import filters from '../../../../../config/admin/filters';
import ProductFilter from '../../../../services/ProductFilter';
import axios from '../../../../axios-config';
import PlatformState from './PlatformState';
import AgencyState from './AgencyState';
import InputSelect from '../../interactive/InputSelect';

export default {
  components: {
    FilterProducts,
    PlatformState,
    AgencyState,
    InputSelect,
  },
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  data() {
    return {
      carrierProductFilters: [],
      carrierInfo: {},
      vendors: [],
      agencies: [],
      statePlatforms: [],
      vendorMeta: {
        name: 'selectVendor',
        label: 'Vendor',
        parentProperty: 'vendorId',
      },
      agencyMeta: {
        name: 'selectAgency',
        label: 'Agency',
        parentProperty: 'agencyId',
      },
      agencyIntegrations: {
        carrierId: null,
        productId: null,
        vendorId: null,
        agencyId: null,
        stateIntegrations: [],
      },
      agencytype: {
        field_name: 'selectAgency',
        field_value: '',
        field_type: 'select',
        values: [],
        placeholder: 'Select One',
        label: 'Agency',
        is_enabled: true,
      },
    };
  },
  computed: {
    productId() {
      return this.currentProduct.productId;
    },
    currentProduct() {
      return this.carrierInfo.products ? this.carrierInfo.products.find(product => product.productId === this.carrierProductFilters.field_value) : {};
    },
    agencyStates() {
      const currentProduct = this.statePlatforms.products ? this.statePlatforms.products.find(product => product.productId === this.carrierProductFilters.field_value) : {};

      return currentProduct.integrationAppointedStates;
    },
  },
  methods: {
    resetVendor() {
      this.agencyIntegrations.vendorId = null;
      this.resetAgency();
    },
    resetAgency() {
      this.agencyIntegrations.agencyId = null;
      this.agencytype.values = [];
      this.resetStateIntegrations();
    },
    resetStateIntegrations() {
      this.agencyIntegrations.stateIntegrations = [];
      this.statePlatforms = [];
    },
    agencyStateKey(key) {
      return `key_${key}_
        ${this.agencyIntegrations.carrierId}_
        ${this.agencyIntegrations.productId}_
        ${this.agencyIntegrations.vendorId}_
        ${this.agencyIntegrations.agencyId}`;
    },
    async saveCarrier() {
      if (
        !this.agencyIntegrations.carrierId ||
        !this.agencyIntegrations.productId ||
        !this.agencyIntegrations.vendorId ||
        !this.agencyIntegrations.agencyId ||
        !this.agencyIntegrations.stateIntegrations.length
      ) {
        return {}; // Short-circuit if not enough data or no changes to save
      }

      return axios.post('carrieragencyintegrations',
        this.agencyIntegrations, // TODO: Only send current product
      ).then((response) => {
        this.$store.commit('updateAlerts', {
          messages: [
            'Success: Your edits have been saved.',
          ],
          variant: 'success',
        });

        return response;
      }).catch((error) => {
        const errorMessage = (error.response && error.response && error.response.data ? error.response.data.Message : 'Unknown error.'); // TODO: Use config value

        this.$store.commit('updateAlerts', {
          messages: [
            `Error: ${errorMessage}`,
          ],
          variant: 'danger',
        });

        window.console.warn('An error occurred while saving carrier.', error);

        return error;
      }).then((response) => {
        this.agencyIntegrations.stateIntegrations = []; // Clear the saved data. TODO: Display response data
        this.requestStatePlatforms(); // TODO: Update API to respond with this data

        return response;
      });
    },
    setProductFilters(carrier) {
      if (carrier.products) {
        // Only use the products that this carrier has
        const productFilters = filters.products_with_icons
          .filter(product => carrier.products
            .find(carrierProduct => (carrierProduct.productId === product.internal_value)));

        const defaultProductFilter = productFilters.slice(0, 1).shift(); // Get first accessible product
        this.carrierProductFilters = new ProductFilter('productFilter', productFilters); // Needed since the default `field_value` is blank string
        this.carrierProductFilters.field_value = defaultProductFilter.internal_value; // Set current product as first accessible product's value
      }
    },
    requestCarrierAgencyIntegrationData() {
      window.console.info('Requesting carrier data...');

      axios.get(`carrieragencyintegrations/${this.$route.query.id}`)
        .then((response) => {
          this.carrierInfo = response.data;
          this.statePlatforms = response.data;

          this.$store.commit('updateCarrier', this.carrierInfo); // Allows parent components to reference the carrier's data

          this.setProductFilters(this.carrierInfo);
        }).catch((error) => {
          window.console.warn('An error occurred while requesting this carrier.', error);
        });
    },
    requestVendors() {
      axios.get('vendors')
        .then((response) => {
          this.vendors = Array.isArray(response.data) ? response.data.map(option => ({
            label: `${option.vendorName} (Vendor Id: ${option.vendorId})`,
            value: option.vendorId,
          })) : [];
        }).catch((error) => {
          window.console.warn('An error occurred while requesting this carrier.', error);
        });
    },
    requestAgencies() {
      this.resetAgency();

      if (!this.agencyIntegrations.vendorId) {
        return; // Short-circuit if no vendorId
      }

      axios.get(`agencies/vendor/${this.agencyIntegrations.vendorId}`)
        .then((response) => {
          this.agencytype.values = Array.isArray(response.data) ? response.data.map(option => ({
            label: `${option.agencyName} (${option.application ? option.application.displayName : ''} SID: ${option.sid})`,
            value: option.agencyId,
          })) : [];
        }).catch((error) => {
          window.console.warn('An error occurred while requesting this carrier.', error);
        });
    },
    requestStatePlatforms() {
      this.resetStateIntegrations();

      if (!this.agencyIntegrations.agencyId) {
        return; // Short-circuit if no agencyId
      }

      axios.get(`carrieragencyintegrations/${this.agencyIntegrations.carrierId}/agency/${this.agencyIntegrations.agencyId}`)
        .then((response) => {
          this.statePlatforms = response.data;
        }).catch((error) => {
          window.console.warn('An error occurred while requesting this carrier.', error);
        });
    },
    agencyStateSelectOptions(agencyState) {
      const agencyStateSelectOptions = Array.isArray(agencyState.integrationPlatforms) ? agencyState.integrationPlatforms.map(option => ({
        label: option.integrationName,
        value: option.integrationId,
      })) : [];

      return agencyStateSelectOptions;
    },
  },
  mounted() {
    this.requestCarrierAgencyIntegrationData();
    this.requestVendors(); // This can be called async since it doesn't depend on other data
  },
  watch: {
    productId: function productId(newValue) {
      this.saveCarrier().then(() => {
        this.agencyIntegrations.productId = newValue; // Update productId after the save
      });
    },
    'agencyIntegrations.vendorId': function agencyIntegrationsVendorId() {
      this.agencytype.field_value = '';
      this.requestAgencies();
    },
    'agencytype.field_value': function agencyIntegrationselect(newValue) {
      this.agencyIntegrations.agencyId = newValue;
    },
    'agencyIntegrations.agencyId': function agencyIntegrationsAgencyId() {
      this.requestStatePlatforms();
    },
    'carrierInfo.carrierId': function carrierInfoCarrierId(newValue) {
      this.agencyIntegrations.carrierId = newValue; // Only updated from `requestCarrierAgencyIntegrationData()`
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/carriers/agencyIntegration/AgencyIntegration.vue?7265216a